import type { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { EmptyState } from '@humanforce/mango-ui-react';
import { Navigate, useLocation } from 'react-router';
import { userStore } from '../../auth/store';

interface ProtectedRouteProps {
  children: ReactNode;
  /** When set, the route itself is gated on this role, not just its nav entry — a direct link/bookmark by a user without the role gets a clean "not authorized" state instead of a page that immediately 403s. */
  requiredRole?: string;
}

export const ProtectedRoute = observer(({ children, requiredRole }: ProtectedRouteProps) => {
  const location = useLocation();

  if (userStore.isInitialising) {
    return <div className="mgo-cluster mgo-justify-center mgo-color-muted" style={{ minHeight: '100vh' }}>Loading...</div>;
  }

  if (!userStore.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (requiredRole && !userStore.roles.includes(requiredRole)) {
    return (
      <EmptyState
        variant="warning"
        title="Page unavailable"
        description="You do not have permission to view this page."
      />
    );
  }

  return <>{children}</>;
});
